import axios from '../../../axios';
import ICVBulkUploadDTO from '../types/ICVBulkUploadDTO';
import ICVBulkUploadRequest from '../types/ICVBulkUploadRequest';
import IExcelImportRequest from '../types/IExcelImportRequest';
import IUploadHistoryRequest from '../types/IUploadHistoryRequest';

const url = '/candidatesearch/api/candidate/bulkupload';

export const createBatchApi = (request: ICVBulkUploadDTO) =>
  axios.post(`${url}/generatebatch`, request);

export const sendResumeToCVParser = (request: ICVBulkUploadRequest) =>
  axios.post(`/candidatesearch/api/mapping/send-resume-to-cv-parser`, request);

export const processExcelRecords = (request: ICVBulkUploadDTO) =>
  axios.post(`${url}/process-excel-records`, request);

export const deleteExcelRecord = (fileId: string) =>
  axios.delete(`${url}/process-excel-records?id=${fileId}`);

export const readExcelRecords = (fileDetails: string) =>
  axios.get(`${url}/read-excel-records/${fileDetails}`);

export const getPendingRecords = (isMapping: boolean) =>
  axios.get(`${url}/recent-pending-files?isMapping=${isMapping}`);

export const importRecords = (request: IExcelImportRequest) =>
  axios.post(`${url}/import-excel-records`, request);
export const getExcelImportHistory = () =>
  axios.get(`/candidatesearch/api/mapping/bulk/import-mappings-stats`);

export const getUploadHistorySearch = (request: IUploadHistoryRequest) =>
  axios.post(`${url}/search`, request);

export const getDetailedUploadHistorySearch = (request: IUploadHistoryRequest) =>
  axios.post(`${url}/details/search`, request);

export const getRecentExcelUploads = () => axios.get(`${url}/recent-excel-uploads`);

export const refreshBatchCounts = (batchCode: string) => axios.get(`${url}/refresh/${batchCode}`);

export const sendEmailNotification = (createdBy: string, filename: string) => {
  return axios.post('api/sendXLSUploadNotificationMail', {
    createdBy: createdBy,
    fileName: filename,
  });
};

export const errorFileForBulkUploads = (request: IUploadHistoryRequest) => {
  return axios.post(`${url}/generateErrorFile`, request);
};
